<template lang="pug">
.cte-top-bar
	.icon.icon-toggle(@click='toggleSideMenu')
	profile-image(
		class="profile-image"
		@profile-click='openUser'
	)
	.headers
		h1.main-header {{ title }}
		h2.header.subtitle(v-if="subtitle") {{ subtitle }}
		.school-dropdown(v-else)
			DropdownSelect(
				:value='selectedSchool'
				:label='"Schools"'
				:options='dropdownOptions'
				@change='onSelectChange'
			)
			//- .loading-circles(v-if='loadingSchools')
			//- 	span
			//- 	span
			//- 	span
</template>

<script>
import ProfileImage from '@/components/ProfileImage';
import DropdownSelect from '@/components/DropdownSelect';

export default {
  name       : 'cte-top-bar',
  components : {
    ProfileImage,
    DropdownSelect,
  },

  props : {
    title    : String,
    subtitle : String, // If provided, replaces the school dropdown filter
  },

  computed : {
    selectedSchool() {
      return this.$store.getters.setSchool;
    },

    schools() {
      return this.$store.getters.schools;
    },

    dropdownOptions() {
      const { schools } = this.$store.getters;
      return [{ label : 'All', value : 'All' }].concat(
        schools.map( school => ( {
          label : school.name,
          value : school.id,
        } ) )
      );
    },

    sideMenuSwiper() {
      return this.$store.getters.sideMenuSwiper;
    },

    savedSchool() {
      return this.$store.getters.savedSchool;
    },
  },

  methods : {
    onSelectChange( value ) {
      this.$store.dispatch( 'setSchool', value );
    },

    openUser() {
      this.$store.dispatch( 'updateStore', ['userSwiperState', 'open'] );
    },

    toggleSideMenu() {
      this.$store.dispatch( 'toggleSideMenu' );
    },

    toggleSchoolMenu( bool ) {
      this.showSchoolList = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
.cte-top-bar {
	position: relative;
	height: 115px;
	box-shadow: $floatingObject;
	padding-top: 10px;
	align-items: center;
	justify-content: flex-end;
	position: relative;
	background: white;
	z-index: 10;

	.icon-toggle {
		position: absolute;
		left: 15px;
	}

	.profile-image {
		position: absolute;
		right: 10px;
		top: 10px;
	}

	.headers {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding-top: 5px;

		.main-header {
			font-size: 24px;
			color: $primary;
			font-weight: 600;
			text-align: center;
		}

		.subtitle {
			font-size: 16px;
			font-weight: 500;
			border-bottom: 2px solid $primary;
			padding: 5px 10px;
			color: $primary;
		}
	}
}

@media only screen and (min-width: 993px) {
	.cte-top-bar {
		.icon-toggle {
			opacity: 0;
			pointer-events: none;
		}
	}
}
</style>
